export const option = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    xAxes: [{ ticks: { fontColor: "#000000", fontSize: 14 } }],
    yAxes: [{ ticks: { fontColor: "#000000",display: false } }],
  },
  legend: { display: false },
  tooltips: {
    callbacks: {
      label: (tooltipItem: any) =>
        `${tooltipItem.xLabel}`,
      title: () => null,
    },
  },
};

export const datasetOptions = {
  borderWidth: 1,
  backgroundColor: [
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(37, 200, 64, 0.2)",
    "rgba(255, 10, 200, 0.2)",
    "rgba(155, 200, 200, 0.2)",
    "rgba(200, 255, 100, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(37, 200, 64, 0.2)",
    "rgba(255, 10, 200, 0.2)",
    "rgba(155, 200, 200, 0.2)",
    "rgba(200, 255, 100, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(37, 200, 64, 0.2)",
    "rgba(255, 10, 200, 0.2)",
    "rgba(155, 200, 200, 0.2)",
    "rgba(200, 255, 100, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(37, 200, 64, 0.2)",
    "rgba(255, 10, 200, 0.2)",
    "rgba(155, 200, 200, 0.2)",
    "rgba(200, 255, 100, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(37, 200, 64, 0.2)",
    "rgba(255, 10, 200, 0.2)",
    "rgba(155, 200, 200, 0.2)",
    "rgba(200, 255, 100, 0.2)",
  ],
  borderColor: [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(37, 200, 64, 1)",
    "rgba(255, 10, 200, 1)",
    "rgba(155, 200, 200, 1)",
    "rgba(200, 255, 100, 1)",
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(37, 200, 64, 1)",
    "rgba(255, 10, 200, 1)",
    "rgba(155, 200, 200, 1)",
    "rgba(200, 255, 100, 1)",
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(37, 200, 64, 1)",
    "rgba(255, 10, 200, 1)",
    "rgba(155, 200, 200, 1)",
    "rgba(200, 255, 100, 1)",
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(37, 200, 64, 1)",
    "rgba(255, 10, 200, 1)",
    "rgba(155, 200, 200, 1)",
    "rgba(200, 255, 100, 1)",
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(37, 200, 64, 1)",
    "rgba(255, 10, 200, 1)",
    "rgba(155, 200, 200, 1)",
    "rgba(200, 255, 100, 1)",
  ],
};
